import {requestRemoteData} from '../../API/api';
import {parseEquivalenceCharges} from '../domain/User.model';
import {mapRemoteData} from '../../common/domain/RemoteData.model';

const GET_SELF_ENDPOINT = 'user/me';
const GET_SELF_DETAILS_ENDPOINT = 'account/userdata';
const RESET_PASSWORD_ENDPOINT = 'user';

/**
 * @param {unknown} user
 * @returns {User}
 */
const parseUser = (user) => {
  const equivalenceCharges = parseEquivalenceCharges(user.recargo);
  return {
    id: user.id, equivalenceCharges, code: user.num_cliente, isComercial: user.isComercial === true,
    // Permisos por usuario (admin): ver tarifas en la ficha y cambiar precio/dto.1 en el carrito
    verTarifas: user.verTarifas === true,
    cambiarPrecioCarrito: user.cambiarPrecioCarrito === true,
    // Elegir en la ficha el lote con el que sale la línea (solo comerciales con permiso)
    elegirLote: user.elegirLote === true,
    // Almacén de BC desde el que pide (p.ej. MADRID); null = el de siempre. Con almacén, el stock que ve es el de ese almacén
    almacen: user.almacen || null,
    // Agentes (códigos de vendedor de BC) del comercial; con más de uno tiene que elegir con cuál sale cada pedido
    salespersonCodes: Array.isArray(user.salespersonCodes) ? user.salespersonCodes : [],
    // false = la empresa usa agente por línea y el comercial no elige agente; si el api no lo manda, se elige como siempre
    eligeAgente: user.eligeAgente !== false
  };
};


/**
 * @returns {Promise<RemoteData<User>>}
 */
export const fetchSelf = () => {
  return requestRemoteData(GET_SELF_ENDPOINT)
                  .then((it) => mapRemoteData(it, parseUser));
};

/**
 * @returns {Promise<RemoteData<UserDetails>>}
 */
export const getSelfDetails = () => {
  return requestRemoteData(GET_SELF_DETAILS_ENDPOINT);
};

/**
 * @param {string} password
 * @param {string} oldPassword
 * @returns {Promise<RemoteData<void>>}
 */
export const resetPassword = (password, oldPassword) => {
  return requestRemoteData(RESET_PASSWORD_ENDPOINT, {
    method: 'PUT',
    body: { password, oldPassword }
  });
};

export const signup = (userInfo, tenantId) => {
  return requestRemoteData('signup', {
    method: 'POST',
    headers: { 'Tenant-Id': tenantId },
    body: userInfo,
    useJwt: false
  });
};

export const onboard = (userInfo, tenantId) => {
  return requestRemoteData('signup/existent', {
    method: 'POST',
    headers: { 'Tenant-Id': tenantId },
    body: userInfo,
    useJwt: false
  });
}

/** Paso 2 del alta: codigo de verificacion del email del solicitante. */
export const verifyRegistrationCode = (info, tenantId) => {
  return requestRemoteData('signup/verify', {
    method: 'POST',
    headers: { 'Tenant-Id': tenantId },
    body: info,
    useJwt: false
  });
};

export const resendRegistrationCode = (info, tenantId) => {
  return requestRemoteData('signup/resend-code', {
    method: 'POST',
    headers: { 'Tenant-Id': tenantId },
    body: info,
    useJwt: false
  });
};

/** Activacion de cuenta por enlace (correo de bienvenida). */
export const fetchActivationStatus = (token) => {
  return requestRemoteData('activation', { queryParams: { token }, useJwt: false });
};

export const activateAccount = (info) => {
  return requestRemoteData('activation', { method: 'POST', body: info, useJwt: false });
};

/** Aviso a la empresa de que un cliente ya autorizado necesita credenciales nuevas (no da acceso). */
export const requestCredentials = (info, tenantId) => {
  return requestRemoteData('signup/credentials-request', {
    method: 'POST',
    headers: { 'Tenant-Id': tenantId },
    body: info,
    useJwt: false
  });
};